"use strict";
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMatchingUISchema = exports.uischemaRegistryReducer = void 0;
var tslib_1 = require("tslib");
var maxBy_1 = tslib_1.__importDefault(require("lodash/maxBy"));
var remove_1 = tslib_1.__importDefault(require("lodash/remove"));
var actions_1 = require("../actions");
var testers_1 = require("../testers");
var uischemaRegistryReducer = function (state, action) {
    if (state === void 0) { state = []; }
    switch (action.type) {
        case actions_1.ADD_UI_SCHEMA:
            return state
                .slice()
                .concat({ tester: action.tester, uischema: action.uischema });
        case actions_1.REMOVE_UI_SCHEMA:
            var copy = state.slice();
            remove_1.default(copy, function (entry) { return entry.tester === action.tester; });
            return copy;
        default:
            return state;
    }
};
exports.uischemaRegistryReducer = uischemaRegistryReducer;
var findMatchingUISchema = function (state) { return function (jsonSchema, schemaPath, path) {
    var match = maxBy_1.default(state, function (entry) {
        return entry.tester(jsonSchema, schemaPath, path);
    });
    if (match !== undefined &&
        match.tester(jsonSchema, schemaPath, path) !== testers_1.NOT_APPLICABLE) {
        return match.uischema;
    }
    return undefined;
}; };
exports.findMatchingUISchema = findMatchingUISchema;
//# sourceMappingURL=uischemas.js.map